import React, { memo } from "react";
import ReactDOM from "react-dom";
import Modal from "../Modal/Modal";


const CustomModal = ({ children, isShowing, onClose }) => {
    return (
        isShowing &&
        ReactDOM.createPortal(
            <Modal rounded="true" open={isShowing} onClose={onClose}>
                {children}
            </Modal>,
            document.getElementById("modal-root")
        )
    );
};

export default memo(CustomModal);
